import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'
import { find } from 'utils/dom'

export default function () {
	const Page = find("[js-page='Cliente']")
	if (!Page) return { init: () => null }

	function syncPageScroll() {
		requestAnimationFrame(() => {
			window.lenis?.resize()
			window.ScrollTrigger?.refresh()

			const maxScroll = Math.max(
				0,
				document.documentElement.scrollHeight - window.innerHeight
			)
			const currentScroll = window.lenis?.scroll ?? window.scrollY

			if (currentScroll > maxScroll) {
				window.lenis?.scrollTo(maxScroll, { immediate: true })
			}
		})
	}

	function setHeroAspectRatio(swiper) {
		const container = find('[data-hero-aspect]', Page)
		const slide = swiper.slides[swiper.activeIndex]
		const ratio = slide?.dataset?.aspectRatio
		if (container && ratio) {
			container.style.aspectRatio = ratio
		}
		requestAnimationFrame(() => {
			swiper.update()
			syncPageScroll()
		})

		if (!container) return

		const onTransitionEnd = (event) => {
			if (event.propertyName !== 'aspect-ratio') return
			container.removeEventListener('transitionend', onTransitionEnd)
			syncPageScroll()
		}

		container.removeEventListener('transitionend', onTransitionEnd)
		container.addEventListener('transitionend', onTransitionEnd)
	}

	function initHeroGallery() {
		const heroEl = find('.swiper-cliente-hero', Page)
		if (!heroEl) return

		const slideCount = heroEl.querySelectorAll('.swiper-slide').length
		if (slideCount < 2) return

		new Swiper(heroEl, {
			modules: [Pagination],
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 500,
			pagination: {
				el: find('.client-hero_gallery-pagination', Page),
				clickable: true,
			},
			on: {
				init: setHeroAspectRatio,
				slideChange: setHeroAspectRatio,
			},
		})
	}

	function init() {
		initHeroGallery()
	}

	return {
		init,
	}
}
